import { Vector2 } from "three"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"

const usePointerRefVector2 = createSharedCachedFactory((
  // engine: Engine
) => {
  const pointerRef = new Vector2()
  return pointerRef
})

export default usePointerRefVector2
